import { BigNum } from '@drift-labs/sdk';
import NumberDisplay from 'src/components/NumberDisplay/NumberDisplay';

interface AccountDepositsCellProps {
	spotDeposits: BigNum;
}

export default function AccountDepositsCell({
	spotDeposits,
}: AccountDepositsCellProps) {
	return (
		<NumberDisplay
			value={spotDeposits}
			type="currency"
			millify={{ threshold: 10_000, precision: 4 }}
			isAccountValueToHide
		/>
	);
}
